class VastPreview

  constructor: (options) ->

    @inited = no

    @options = $.extend {},
      id: null
      adTagUrl: ''
      adsResponse: ''
      adLabel: 'Advertisement'
      adsRenderingSettings: {}
      autoPlayAdBreaks: on
      contribAdsSettings: {}
      debug: no
      forceNonLinearFullSlot: on
      locale: 'en'
      nonLinearWidth: 0
      nonLinearHeight: 0
      numRedirects: 10
      showControlsForJSAds: no
      showCountdown: on
      vpaidAllowed: on
      vpaidMode: google.ima.ImaSdkSettings.VpaidMode.ENABLED, options

    @errPrefix = "VAST error:"

    @player = videojs @options.id
    @check_adserver_preview_health()

  play_ad: =>
    @check_adserver_preview_health()
    if not @inited
      return

    @player.ima @options
    @player.ima.requestAds()
    @player.play()

  replay_ad: =>
    if not @inited
      @play_ad()

    if 'function' == (typeof @player.ima.isInitialized) and @player.ima.isInitialized()
      @hide_spinner()
      @player.ima.reset()

    @player.errorDisplay.close()

    @player.off 'google.ima.adsManagerLoaded'
    @player.on 'google.ima.adsManagerLoaded', =>
      @player.ima.start()

    @play_ad()


  get_player: =>
    @player

  destroy: =>
    if not @inited
      return
    @player.ima.reset()
    @player.dispose()

  show_spinner: =>
    @player.addClass 'vjs-waiting'
    @player.loadingSpinner.show()

  hide_spinner: =>
    @player.removeClass 'vjs-waiting'
    @player.loadingSpinner.hide()

  register_player_listeners: =>
    if @inited
      return

    $(@player.bigPlayButton.el()).on 'click', =>
      @play_ad()

    @player.on 'adserror', (e, adErrorEvent) =>
      @player.errorDisplay.close()
      @hide_spinner()
      if not 'getError' of adErrorEvent
        @player.error "#{@errPrefix} unknown"
      else
        $('#ima-ad-container').hide()
        err = adErrorEvent.getError()
        errMsg = if err and err.getMessage() then err.getMessage() else 'unknown'
        @player.error __("#{@errPrefix} #{errMsg}")
    @player.on 'adtimeout', =>
      @player.error __("#{@errPrefix} Timeout exceeded")

  check_adserver_preview_health: =>
    window.aborting = on
    $.ajax(
      url: @options.adTagUrl
      async: no
    ).fail =>
      @player.error __("#{@errPrefix} Creative is in validation state, please wait")
    .done =>
      $(@player.bigPlayButton.el()).css 'z-index', 1500
      @register_player_listeners()
      @inited = on
    .always ->
      window.aborting = no